<div class="h-100 box d-flex flex-column px-2 pb-5">
    <div class="px-4">
        <div class="text-l font-semi-bold border-b border-dark py-5">{{ 'v3-byoc-popup-create-mission-title' | translate }}</div>
    </div>

    <div class="flex-grow-1">
        <div class="py-4 px-4 relative inner">
            <div class="mb-4">
                <span class="font-semi-bold text-default text-s" translate>v3-byoc-popup-create-mission-course-title</span
                ><span class="text-s" translate> v3-global-or </span>
                <span appByocCreateCourse [isSubmodal]="true" (click)="createCourseClick()" class="text-info link pointer text-s" translate
                    >v3-byoc-popup-create-mission-course-link</span
                >
            </div>

            <div class="mb-4">
                <app-forms-input
                    [control]="searchFormControl"
                    icon="lens"
                    classes="info"
                    [placeholder]="'v3-byoc-popup-create-episode-course-input-placeholder' | translate"
                    formControlDataTest="search"
                ></app-forms-input>
            </div>

            <div class="d-flex align-items-center mb-4">
                <div class="me-4">
                    <!-- Radio -->
                    <div class="radio radio-success">
                        <input
                            id="form-radio-origin-0"
                            type="radio"
                            [formControl]="originControl"
                            [value]="0"
                            name="form-radio-origin"
                            formControlDataTest="all"
                        />
                        <label for="form-radio-origin-0" class="text-odd-xxs text-uppercase">
                            {{ 'v3-global-all' | translate }}
                            <span class="icon" [inlineSVG]="'assets/icons.svg#dot'"></span>
                        </label>
                    </div>
                </div>
                <div class="me-4">
                    <!-- Radio -->
                    <div class="radio radio-success">
                        <input
                            id="form-radio-origin-1"
                            type="radio"
                            [formControl]="originControl"
                            [value]="1"
                            name="form-radio-origin"
                            formControlDataTest="stCourses"
                        />
                        <label for="form-radio-origin-1" class="text-odd-xxs text-uppercase">
                            {{ 'v3-byoc-popup-create-episode-course-radio-st-courses' | translate }}
                            <span class="icon" [inlineSVG]="'assets/icons.svg#dot'"></span>
                        </label>
                    </div>
                </div>
                <div>
                    <!-- Radio -->
                    <div class="radio radio-success">
                        <input
                            id="form-radio-origin-2"
                            type="radio"
                            [formControl]="originControl"
                            [value]="2"
                            name="form-radio-origin"
                            formControlDataTest="customCourses"
                        />
                        <label for="form-radio-origin-2" class="text-odd-xxs text-uppercase">
                            {{ 'v3-byoc-popup-create-episode-course-radio-custom-courses' | translate }}
                            <span class="icon" [inlineSVG]="'assets/icons.svg#dot'"></span>
                        </label>
                    </div>
                </div>
            </div>

            <app-byoc-mission-step-course-list
                #coursesList
                [onHold]="creatingCourse"
                [searchFormControl]="searchFormControl"
                [originControl]="originControl"
            ></app-byoc-mission-step-course-list>
        </div>
    </div>

    <div class="theme-new d-flex align-items-center px-4">
        <button (click)="cancelClick()" class="btn btn-primary ms-auto" buttonDataTest="cancelButton" translate>v3-button-cancel</button>
        <button (click)="backClick()" class="btn btn-primary" buttonDataTest="backButton" translate>v3-button-back</button>
        <button
            *ngIf="selectedCoursesNumber <= 1"
            [disabled]="!courses.valid || selectedCoursesNumber === 0"
            (click)="saveClick()"
            class="btn"
            [ngClass]="[courses.valid && selectedCoursesNumber > 0 ? 'btn-secondary' : 'btn-disabled']"
            buttonDataTest="saveButton"
            translate
        >
            v3-button-save
        </button>
        <button
            *ngIf="selectedCoursesNumber > 1"
            (click)="goToPositionSetting()"
            class="btn btn-secondary"
            [ngClass]="[!courses.valid && selectedCoursesNumber > 0 ? 'btn-disabled' : 'btn-secondary']"
            buttonDataTest="continueButton"
            translate
        >
            v3-button-continue
        </button>
    </div>

    <app-loader *ngIf="saving" loaderType="cover" overlayColor="white"></app-loader>
</div>
